import React from 'react'

function IconNetwork({ color = 'currentColor', ...props }) {
  return (
    <svg
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35253 22.4672C8.02392 23.038 7.3197 23.194 6.77959 22.8155L0.54973 18.4496C0.208363 18.2104 1.99464e-06 17.8003 7.72916e-07 17.3677L0 6.84987C-1.58295e-07 6.42398 0.202011 6.03644 0.534955 5.82361L9.38601 0.165691C9.73296 -0.0560894 10.1702 -0.0551695 10.5323 0.168105L19.7735 5.86581C20.1477 6.09654 20.3817 6.52753 20.3817 6.98615L20.3816 17.3796C20.3816 17.392 20.3814 17.4045 20.3811 17.4169C20.388 17.6095 20.3535 17.8049 20.2725 17.9877C20.1239 18.3229 19.8498 18.5453 19.5378 18.6243L13.5597 22.8298C13.039 23.1961 12.3262 23.0238 11.9676 22.4451C11.609 21.8663 11.7404 21.1002 12.261 20.7339L16.88 17.4846L9.83655 13.5962L3.63066 17.7075L7.96958 20.7482C8.50969 21.1267 8.68114 21.8963 8.35253 22.4672ZM18.0922 7.63499L18.0921 15.4141L10.9103 11.4493V6.0943C10.9103 5.41921 10.3895 4.85867 9.74697 4.84231C9.10446 4.82595 8.58361 5.35996 8.58361 6.03506L8.58361 11.469L2.28945 15.6388L2.28945 7.63064L10.0447 2.67322L18.0922 7.63499Z"
        fill={color}
      />
    </svg>
  )
}

export default IconNetwork
